// extracted by mini-css-extract-plugin
export var addButton = "_ok-0";
export var border = "_ok-8";
export var check = "_ok-h";
export var danger = "_ok-6";
export var dropdownContainer = "_ok-1";
export var editModalBody = "_ok-j";
export var footerContainer = "_ok-i";
export var fullWidth = "_ok-a";
export var hide = "_ok-9";
export var icon = "_ok-3";
export var input = "_ok-7";
export var inputFlex = "_ok-b";
export var inputWrapper = "_ok-c";
export var manualFocus = "_ok-5";
export var optionButton = "_ok-4";
export var pillWrapper = "_ok-e";
export var pointer = "_ok-2";
export var showOverflow = "_ok-f";
export var tagsFlex = "_ok-d";
export var xButton = "_ok-g";